export interface AuthIdentity {
  email: string;
  role: string;
}

interface SessionResponse {
  authenticated: boolean;
  email?: string;
  role?: string;
}

async function parseJson<T>(response: Response): Promise<T> {
  return (await response.json()) as T;
}

export async function checkSession(): Promise<AuthIdentity | null> {
  const res = await fetch("/api/auth/session", { credentials: "include" });
  if (!res.ok) return null;
  const data = await parseJson<SessionResponse>(res);
  return data.authenticated && data.email && data.role ? { email: data.email, role: data.role } : null;
}

export async function login(
  email: string,
  password: string,
): Promise<{ ok: true; identity: AuthIdentity } | { ok: false; error: string }> {
  const res = await fetch("/api/auth/login", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  const data = await parseJson<{ error?: string; email?: string; role?: string }>(res).catch(
    () => ({}) as { error?: string; email?: string; role?: string },
  );

  if (res.ok && data.email && data.role) {
    return { ok: true, identity: { email: data.email, role: data.role } };
  }

  return { ok: false, error: data.error ?? "Unable to sign in. Please try again." };
}

export async function logout(): Promise<void> {
  await fetch("/api/auth/logout", { method: "POST", credentials: "include" });
}
